// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"4bf3ef95","735":"39ffc3e0","936":"8ecbdeaa"}[chunkId] + ".chunk.js";
};